import { useMemo, useState } from 'react'

const ITEMS_POR_PAGINA_POR_DEFECTO = 15

export const usePaginacion = (
  listaItems,
  itemsPorPaginaInicial = ITEMS_POR_PAGINA_POR_DEFECTO,
  { totalItems } = {}
) => {
  const [paginaActual, setPaginaActual] = useState(1)
  const [itemsPorPagina, setItemsPorPagina] = useState(itemsPorPaginaInicial)

  const totalPaginas = useMemo(
    () => Math.max(1, Math.ceil((totalItems ?? listaItems?.length ?? 0) / itemsPorPagina)),
    [listaItems, itemsPorPagina, totalItems]
  )

  const itemsActual = useMemo(() => {
    if (!listaItems?.length) return []
    if (totalItems !== undefined && totalItems !== null) return listaItems
    const indiceUltimo = paginaActual * itemsPorPagina
    const indicePrimero = indiceUltimo - itemsPorPagina
    return listaItems.slice(indicePrimero, indiceUltimo)
  }, [listaItems, paginaActual, itemsPorPagina, totalItems])

  return {
    itemsActual,
    paginaActual,
    setPaginaActual,
    itemsPorPagina,
    setItemsPorPagina,
    totalPaginas
  }
}
